import style from "./SellerTypeCard.module.scss"
import sellerTypeIcon from "../../assets/images/Group.png"
import React from "react";

export default function SellerTypeCard() {
    return (
        <div className={style.layout}>
            <img src={sellerTypeIcon} alt="asdasd"/>
            <p className={style.sellerTypeTitle}>
                فروشنده حقیقی
            </p>
            <p className={style.sellerTypeSubTitle}>
                فروشنده حقیقی، یک فرد است که مشخصاتی مانند نام، نام خانوادگی، تاریخ تولد، کد ملی، شماره شناسنامه و...
                دارد، اما شرکت و کد اقتصادی ندارد
            </p>
            <span className={style.fake}>
                123456789
            </span>

        </div>
    )
}